import { render, staticRenderFns } from "./templateThird.vue?vue&type=template&id=e4d54eea&scoped=true&"
import script from "./templateThird.vue?vue&type=script&lang=ts&"
export * from "./templateThird.vue?vue&type=script&lang=ts&"
import style0 from "./templateThird.vue?vue&type=style&index=0&id=e4d54eea&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d54eea",
  null
  
)

export default component.exports